import { isObject } from 'libs/utils/object';
export function isAxiosResponse(response) {
  return response != null && isObject(response) && 'data' in response && 'status' in response && 'statusText' in response && 'headers' in response && 'config' in response && 'request' in response;
}
export function isAxiosError(error) {
  return error === null || error === void 0 ? void 0 : error.isAxiosError;
}